<template>
  <div style="background-color: white;">
    <v-dialog v-model="dialogPreview.status" max-width="800">

      <div style="background-color: white;">

        <v-row justify="center">
          <!-- Información básica del grupo -->
          <v-col cols="12" class="pb-1">
            <v-card class="elevation-0">
              <v-card-text>
                <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
                  Ejercicio
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" class="pb-1">
            <v-card class="elevation-0">
              <v-card-text>
                <div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
                  Calificación: {{ calificacion }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row v-for="(pregunta, i ) in preguntas" :key="i" justify="center">
          <v-col cols="12" sm="10" md="8" lg="6" >
            <v-card class="shadowCard px-0">
              <v-card-title primary-title class="grey--text text-body-1">
                Pregunta {{ pregunta.num_pregunta }} {{ i + 1 }}
                <v-spacer></v-spacer>
                Valor {{ pregunta.valor }}
              </v-card-title>
              <v-card-subtitle class="text-h5 black--text">
                Respuesta: {{ pregunta.correcta === 4 ? 'd' : pregunta.correcta === 3 ? 'c' : pregunta.correcta === 2 ? 'b' : 'a'  }}
              </v-card-subtitle>
              <v-img
                v-if="pregunta.tiene_imagen == 1 && !pregunta.ruta_imagen.match('youtube')"
                :src="(item.escuela == 2 ? 'https://lms.fastenglish.com.mx/' : 'https://lms.inbi.mx/') + pregunta.ruta_imagen"
               ></v-img>


               <iframe
                v-if="pregunta.tiene_imagen == 1 && pregunta.ruta_imagen.match('youtube')"
                :src="pregunta.ruta_imagen"
                width="100%"
                height="400"
                frameborder="0"
                class="pa-2"
                allowfullscreen
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              >
            </iframe>

              <span
                v-if="pregunta.tiene_imagen == 1 && pregunta.ruta_imagen.match('youtube')"
                class="text-h6 ml-4"
              >
                {{ pregunta.pregunta }}
              </span>

               <div v-if="pregunta.tiene_audio_pregunta == 1" class="text-center mt-2 pb-0">
                 <audio controls>
                  <source :src="(item.escuela == 2 ? 'https://lms.fastenglish.com.mx/' : 'https://lms.inbi.mx/') + pregunta.ruta_audio_pregunta" type="audio/mpeg"></audio>
                </audio>
               </div>

               <v-card-text class="text-center pt-0">


                <v-chip-group
                v-model="pregunta.eleccion"
                active-class="primary--text text--accent-4"
                column
                required
              >
              <v-chip
              :color="pregunta.correcta === pregunta.eleccion && pregunta.eleccion === 1 ? 'green': pregunta.eleccion === 1 ? 'red' : ''"
              :value="1">
                a) {{ pregunta.valor1 }}
              </v-chip>

              <v-chip
              :color=" pregunta.correcta === pregunta.eleccion && pregunta.eleccion === 2 ? 'green': pregunta.eleccion === 2 ? 'red' : ''"
               :value="2">
                b) {{ pregunta.valor2 }}
              </v-chip>

              <v-chip
              :color=" pregunta.correcta === pregunta.eleccion && pregunta.eleccion === 3 ? 'green': pregunta.eleccion === 3 ? 'red' : ''"
              :value="3">
                c) {{ pregunta.valor3 }}
              </v-chip>

              <v-chip
              :color=" pregunta.correcta === pregunta.eleccion && pregunta.eleccion === 4 ? 'green': pregunta.eleccion === 4 ? 'red' : ''"
              :value="4">
                d) {{ pregunta.valor4 }}
              </v-chip>
            </v-chip-group>

               </v-card-text>
            </v-card>
          </v-col>

        </v-row>

        <v-row justify="center">
          <!-- El boton solo debe aparecer siempre y cuando no haya contestado el ejercicio -->
          <v-col cols="12" sm="10" md="8" lg="6"  v-if="preguntas.length > 0">
            <v-card-actions>
              <v-btn class="btn-grad text-capitalize" rounded
                large
                dark
                block
                @click="enviarRespuesta()"
                :disabled="disabled"
                :loading="loading"
              >
                <span v-if="!respuestaEnviada">Enviar respuestas</span>
              </v-btn>

            </v-card-actions>
          </v-col>
        </v-row>
      </div>

    </v-dialog>
  </div>
</template>

<script>

export default {
	  name: "PreviewLeccion",
	  data: () => ({
	  	valid: true,
	  	rules: {
        required: value => !!value || 'Requerido.'
      },

	  	url: '',
	  	show: false,
     	preguntas:[],

     	selection: 0,

     	disabled: false,
     	loading: false,
     	respuestaEnviada: false,

     	loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},
     	respuestaAlerta: false,

     	calificacion: 0,
     	calificaciontotal:0,
     	ejercicioResuelto: false,
      recursoRescuelto: {},

     	editable: false,
      item: {
        id_evaluacion: null,
        id_alumno: null,
        id_grupo: null,
        escuela: null
      },
      ejericioPadre: null
	  }),

    props: [
      'dialogPreview'
    ],

	  methods:{

      async initialize ( id_evaluacion, id_alumno, id_grupo, escuela, ejericioPadre ){

        if( id_evaluacion && id_alumno && id_grupo && escuela ){
          this.item = {
            id_evaluacion,
            id_alumno,
            id_grupo,
            escuela
          }
          this.ejericioPadre = ejericioPadre
        }

	  		this.cargar = true
	  		// Guardamos el id de la evaluacion

		  	const payload = {
		  		id_evaluacion: this.item.id_evaluacion,
		  		id_usuario: this.item.id_alumno,
		  		id_grupo: this.item.id_grupo,
		  		editable: this.editable,
          escuela: this.item.escuela
		  	}

		  	// Hacer la ptetición
		  	this.$http.post('get.recurso.resuelto', payload).then(response => {
          this.recursoRescuelto = response.data.recursoRescuelto
		  		this.ejercicioResuelto = response.data.ejercicioResuelto
		  		this.preguntas         = response.data.preguntas
		  		this.calificaciontotal = response.data.calificaciontotal
		  		this.calificacion      = response.data.recursoRescuelto.calificacion
		  		this.idResultado       = response.data.recursoRescuelto.id
		  		this.disabled = false
		  		this.loading  = false
		  		this.cargar   = false
		  	}).catch( error =>{
		  		this.validarErrores ( error )
	  		}).finally( () => { this.cargar = false })

		  	this.preguntas.evaluacion = []
	  	},

	  	validarDatos () {
	  		this.calificacion = 0
	  		for( const i in this.preguntas){
	  			let { eleccion, num_pregunta, respuesta, correcta, valor } = this.preguntas[i]
	  			if( !eleccion ){
	  				this.parametros.mensaje      = 'Por favor, contesta la pregunta #' + num_pregunta
	  				this.parametros.color        = '#FF2C2C'
      			this.parametros.dialogError  = true
      			this.respuestaAlerta = true
	  				return false
	  			}

	  			if( eleccion == correcta ){ this.preguntas[i].respuesta = 1; this.calificacion += valor}
	  			else{ this.preguntas[i].respuesta = 0 }

	  		}
	  		return true
      },

	  	enviarRespuesta( ){
	  		if( this.validarDatos() ){
		  		const payload = {
		  			calificacion:      this.calificacion,
		  			preguntas:         this.preguntas,
		  			idResultado:       this.idResultado,
            escuela:           this.item.escuela
		  		}

		  		this.disabled = true
		  		this.loading  = true
		  		this.cargar   = true

		  		// Hacer la ptetición
		  		this.$http.post('get.recurso.contestar', payload).then(response => {
			  		this.parametros.mensaje      = 'Ejercicio Realizado'
	  				this.parametros.color        = 'success'
	    			this.parametros.dialogError  = true
	    			this.respuestaAlerta = true
            this.ejericioPadre.calificacion = this.calificacion
			  		this.initialize().then()

            // Mostrar SweetAlert de éxito
            this.$swal({
              title: 'Respuestas actualizadas',
              text: 'La respuesta se ha guardado correctamente.',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false
            });

			  	}).catch( error =>{
			  		this.disabled = false
			  		this.loading  = false
			  		this.cargar   = false
			  		this.validarErrores ( error )
		  		}).finally( () => { this.cargar = false })
		  	}
	  	},

	  	validarErrores ( value ){
	  		this.cargar = false
  			if( value.status == 400 || value.status == 500 ){
    			this.parametros.mensaje = value.body.message
  				this.parametros.color        = '#FF2C2C'
    			this.parametros.dialogError  = true
    			this.respuestaAlerta = true
    		}
	  	}
	  }
	};
</script>

<style scoped>
	.avatares{
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}

	.shadowCard{
		border-radius: 15px !important;
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.05)  !important;
	}

	.colorCurso{
		color: #006093;
	}

	.v-expansion-panel-content__wrap{
		padding-right: 0px !important;
		padding-left: 0px !important;
	}



	.btn-grad {
		background-image: linear-gradient(310deg, #2152ff 0%, #21d4fd 100%);
	}



</style>

